import React, { useState } from 'react'

import classNames from 'classnames'

import CoverArt from '@components/shared/CoverArt'
import NFIcon from '@components/shared/NFIcon'
import Product from '@models/Product'
import Score from '@models/Score'
import { useSelection } from '@providers/SelectionProvider'

interface Props {
  score: Score | Product
}

const CoverArtEditableHandle: React.FC<Props> = ({ score }: Props) => {
  const { isSelected, events, isEditing, isSorting } = useSelection()
  const [hover, setHover] = useState(false)

  const selected = isSelected(score)
  const showIcon = (hover || selected || isEditing) && !isSorting
  return (
    <>
      {showIcon && (
        <div className="absolute inset-0 flex flex-row items-center justify-center">
          <NFIcon
            icon={selected ? 'checkbox-check' : 'checkbox'}
            className={classNames(
              'text-center text-h3',
              selected ? 'text-blue' : 'text-gray-icons dark:text-gray-icons-dm'
            )}
          />
        </div>
      )}
      <button
        type="button"
        disabled={isSorting}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onMouseDown={(e) => events.onMouseDown(score, e)}
        onMouseUp={(e) => events.onMouseUp(score, e)}
        // onTouchStart={(e) => events.onTouchStart(score, e)}
        // onTouchEnd={(e) => events.onTouchEnd(score, e)}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}>
        <CoverArt
          url={score.cover_art_url}
          overlay={score.cover_art_directive}
          className={classNames(
            'shadow-none w-[75px] h-[75px] max-w-[75px] max-h-[75px] z-10 bg-gray-light dark:bg-black-bg',
            showIcon ? 'opacity-0' : 'opacity-100'
          )}
        />
      </button>
    </>
  )
}

export default CoverArtEditableHandle
